import "./FolderCard.css";
import { Link } from "react-router-dom";
import config from "../../config";

const FolderCard = (props) => {
  const OBR2 = "/images/thumb1.png";
  const OBR3 = "/images/thumb2.png";
  const date = new Date(props.date);
  const month = date.toLocaleString("default", { month: "long" });
  const day = date.getDate();
  const year = date.getFullYear();

  return (
    <Link to={props.url} style={{ textDecoration: "none", color: "inherit" }}>
      <div className="folder-container d-flex flex-column align-items-center m-3">
        <div className="folder-thumbnail">
          <img src={`${config.api}${props.thumbnail}`} alt="Thumbnail" />
          <img src={OBR2} alt="Logo2" />
          <img src={OBR3} alt="Logo2" />
        </div>
        <h3 className="text-center">
          <b>{props.name}</b>
        </h3>
        <p>
          {day}. {month} {year}
        </p>
        {props.category !== undefined && (
          <span className="category">{props.category}</span>
        )}
      </div>
    </Link>
  );
};
export default FolderCard;

